import { Box, IconButton } from "@material-ui/core";
import { PaymentPlanLineCard } from "./PaymentPlanLineCard";
import React, { useEffect } from "react";

export const PaymentPlanLines = ({ paymentPlan, currentPaymentPlanLine }) => {
  useEffect(() => {
    scrollIntoView(currentPaymentPlanLine.id);
  }, []);

  const scrollIntoView = (paymentPlanLineId) =>
    document
      .getElementById(`line-${paymentPlanLineId}`)
      ?.scrollIntoView({ behavior: "smooth" });

  return (
    <>
      <Box
        mb={1}
        width={"100%"}
        display={"flex"}
        justifyContent={"center"}
        color={"grey.400"}
      >
        <IconButton
          size={"small"}
          onClick={() => scrollIntoView(paymentPlan.lines[0].id)}
        >
          <i className={"material-icons-outlined"}>expand_less</i>
        </IconButton>
      </Box>
      <Box height={"300px"} overflow={"scroll"}>
        {paymentPlan.lines.map((paymentPlanLine) => (
          <Box
            key={paymentPlanLine.id}
            id={`line-${paymentPlanLine.id}`}
            mb={1}
          >
            <PaymentPlanLineCard
              selected={paymentPlanLine.id === currentPaymentPlanLine.id}
              paymentPlanLine={paymentPlanLine}
            />
          </Box>
        ))}
        {/*<Box height={230} />*/}
      </Box>
      <Box
        mt={1}
        width={"100%"}
        display={"flex"}
        justifyContent={"center"}
        color={"grey.400"}
      >
        <IconButton
          size={"small"}
          onClick={() =>
            scrollIntoView(paymentPlan.lines[paymentPlan.lines.length - 1].id)
          }
        >
          <i className={"material-icons-outlined"}>expand_more</i>
        </IconButton>
      </Box>
    </>
  );
};
